import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function LivestreamGuestNameGate({
  productName,
  imageUrl,
  pageTitle,
  submitting,
  error,
  onSubmit,
}: {
  productName: string;
  imageUrl?: string;
  pageTitle: string;
  submitting: boolean;
  error: string | null;
  onSubmit: ({ name }: { name: string }) => void;
}) {
  const [name, setName] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed || submitting) return;
    onSubmit({ name: trimmed });
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className="min-h-dvh flex flex-col items-center justify-center bg-black px-6 text-white">
        <div className="w-full max-w-sm space-y-6">
          <div className="text-center">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={productName}
                className="mx-auto mb-4 h-40 w-40 rounded-lg object-cover shadow-xl"
              />
            ) : null}
            <h1 className="text-2xl font-bold">{productName}</h1>
            <p className="mt-2 text-sm text-white/60">Enter your name to join the livestream</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="livestream-guest-name" className="mb-1 block text-sm text-white">
                Your name
              </label>
              <Input
                id="livestream-guest-name"
                value={name}
                onChange={(event) => setName(event.target.value)}
                placeholder="Your name"
                autoComplete="name"
                autoFocus
                disabled={submitting}
                className="border-white/20 bg-white/10 text-white placeholder:text-white/50"
              />
            </div>
            {error ? <p className="text-sm text-red-400">{error}</p> : null}
            <Button type="submit" disabled={submitting || !name.trim()} className="w-full">
              {submitting ? "Joining…" : "Join livestream"}
            </Button>
          </form>
        </div>
      </div>
    </>
  );
}
